.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: visible;
  justify-content: flex-start;

  #contact-details-section-info {
    color: var(--body-text-arrows-400);
  }

  #contact-details-section-footer {
    color: var(--body-text-arrows-400);
  }

  .form-subtitle {
    text-transform: uppercase;
    color: var(--chart-300-icon-buttons);
  }

  .form-subtitle-info {
    color: var(--grey-layout-300-50-opacity);
    width: 480px;
  }

  #contact-details-import-button {
    margin-bottom: calc(var(--spacer) * 4);
    margin-right: auto;
  }
}
